import { Component, Input } from "@angular/core";

import {
  Discussion,
  DiscussionVote,
  VoterListConfig,
} from "../../../../models";
import { DiscussionVoteListResult } from "../../../../interfaces";
import { DiscussionVoteService } from "../../../../services";

@Component({
  selector: "voter-list",
  templateUrl: "./voter-list.component.html",
  styleUrls: [
    "./voter-list.component.scss",
    "../../../../../../assets/icon/icofont/css/icofont.scss",
  ],
})
export class VoterListComponent {
  constructor(private discussionVoteService: DiscussionVoteService) {}

  private query: VoterListConfig;
  public results: DiscussionVote[];
  public loading: boolean = false;
  public currentPage: number = 1;
  public totalPages: number = 1;
  public totalCount: number;

  @Input() discussion: Discussion;
  @Input() limit: number;
  @Input()
  set config(config: VoterListConfig) {
    if (config) {
      this.query = config;
      this.currentPage = 1;
      this.runQuery();
    }
  }

  public fetchVoters() {
    this.discussionVoteService
      .fetchVoters(this.discussion, this.query)
      .subscribe((data: DiscussionVoteListResult) => {
        this.loading = false;
        this.results = data.votes;
        this.totalCount = data.voteCount.total;
        this.totalPages = data.pages.total;
      });
  }

  public setPageTo(pageNumber: number) {
    this.currentPage = pageNumber;
    this.runQuery();
  }

  public runQuery() {
    this.loading = true;
    this.results = [];

    if (this.limit) {
      this.query.limit = this.limit;
      this.query.offset = this.limit * (this.currentPage - 1);
    }

    this.fetchVoters();
    window.scroll(0, 0);
  }
}
